export default "__VITE_ASSET__f5d89a26__"